import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";

// Margins on the Feed's filter toolbar container. Own SPACING_PICKER metadata
// so it resolves independently of any feed-level Margins option.
export default class FilterToolbarMargins extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter Margins",
    component: inspectorTools.SPACING_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      options: themeStructure.size.spacing,
      heading: "Filter Margins",
    },
  };

  static defaultValue = {
    top: null,
    right: null,
    bottom: null,
    left: null,
  };

  static convertConfigValueToCompiledValue(configValue, themeId = null, themeMode = null) {
    const dimensions = {};

    Object.keys(this.defaultValue).forEach(key => {
      if (configValue[key] === null || configValue[key] === undefined) {
        dimensions[key] = "0px";
      } else if (typeof configValue[key] === "string" && !configValue[key].includes("px")) {
        dimensions[key] = BaseOption._getStyleValuePropertiesFromTheme(
          "size.spacing",
          themeId,
          themeMode,
          configValue[key],
        );
      } else {
        let value = configValue[key];
        if (!String(configValue[key]).includes("px")) {
          value += "px";
        }
        dimensions[key] = value;
      }
    });

    return dimensions;
  }
}
